export default "__VITE_ASSET__d60ad4dc__"